import Styled from './StopsTooltip.styled';
import _map from 'lodash/map';
import { COLOR_VARIANTS, Typography, TYPOGRAPHY_VARIANT } from '@tajawal/ct-web-design-system';
import { useTranslation } from 'react-i18next';
import { buildTestId } from '@/utils/helpers.utils';

type StopsTooltipProps = {
  segmentStops: {
    mainText: string;
    airport: string;
    waitingTime: string;
  }[];
  stopsLength: number;
  testId: string;
};

function StopsTooltip({ segmentStops, stopsLength, testId }: StopsTooltipProps) {
  const { t } = useTranslation();

  return (
    <Styled.StopsTooltipContent>
      {_map(segmentStops, (segment, index) => {
        if (!segment) {
          return null;
        }
        const stopInfoContent = `+ ${stopsLength - 2} ${t('SearchResults.StopsInfoTooltip_More_Stop')}`;

        return (
          <div key={`Stop-${segment.airport}`}>
            {stopsLength > 1 && index === 1 && (
              <Typography
                testId={buildTestId(testId, 'FirstStop')}
                color={COLOR_VARIANTS.GAINSBORO}
                component="p"
                variant={TYPOGRAPHY_VARIANT.BODY2}
              >
                {t('SearchResults.StopsInfoTooltip_First_Stop')}
              </Typography>
            )}
            {stopsLength > 1 && index === 2 && (
              <Typography
                testId={buildTestId(testId, 'SecondStop')}
                color={COLOR_VARIANTS.GAINSBORO}
                component="p"
                variant={TYPOGRAPHY_VARIANT.BODY2}
              >
                {t('SearchResults.StopsInfoTooltip_Second_Stop')}
              </Typography>
            )}
            {stopsLength > 2 && index > 2 && (
              <Typography
                testId={buildTestId(testId, 'OtherStop')}
                color={COLOR_VARIANTS.GAINSBORO}
                component="p"
                variant={TYPOGRAPHY_VARIANT.BODY2}
              >
                {stopInfoContent}
              </Typography>
            )}
            <Styled.StopsTooltipWaitingTime>
              <Typography
                testId={buildTestId(testId, 'WaitingTimeLabel')}
                color={COLOR_VARIANTS.WHITE}
                component="p"
                variant={TYPOGRAPHY_VARIANT.BODY2}
              >
                {t('SearchResults.StopsWaitingTime')}
              </Typography>
              <Typography
                testId={buildTestId(testId, 'WaitingTimeValue')}
                color={COLOR_VARIANTS.WHITE}
                component="h4"
                variant={TYPOGRAPHY_VARIANT.HEADING4SEMBLD}
              >
                {segment.waitingTime}
              </Typography>
              <Typography
                testId={buildTestId(testId, 'CommonIn')}
                color={COLOR_VARIANTS.WHITE}
                component="p"
                variant={TYPOGRAPHY_VARIANT.BODY2}
              >
                {t('Common.In')}
              </Typography>
              <Typography
                testId={buildTestId(testId, 'Airport')}
                color={COLOR_VARIANTS.WHITE}
                component="h4"
                variant={TYPOGRAPHY_VARIANT.HEADING4SEMBLD}
              >
                {segment.airport}
              </Typography>
            </Styled.StopsTooltipWaitingTime>
          </div>
        );
      })}
    </Styled.StopsTooltipContent>
  );
}

export default StopsTooltip;
